import { render } from "./MiniProgramModal.vue?vue&type=template&id=1f5c8469"
import script from "./MiniProgramModal.vue?vue&type=script&lang=js"
export * from "./MiniProgramModal.vue?vue&type=script&lang=js"

import "@/styles/MiniProgramModal.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__